import { api } from '../../AxiosConfig';

export class RecorrenciasService {
    getAll() {
        return api.get('/horarios/recorrencias');
    }

    getById(recorrenciaId: string) {
        return api.get(`/horarios/recorrencia/${recorrenciaId}`);
    }

    getByAssinaturaId(assinaturaId: string) {
        return api.get(`/horarios/recorrencias/assinatura/${assinaturaId}`);
    }

    getHorariosByRecorrenciaId(recorrenciaId: string) {
        return api.get('horarios/getByRecorrenciaId', {params: { recorrenciaId }});
    }

    updateHorarioPrice(horarioId: string, price: number) {
        return api.patch(`/horarios/price/${horarioId}`, { price });
    }

    deleteRecorrencia(recorrenciaId: string) {
        return api.delete('horarios/recorrencia', {params: { recorrenciaId }});
    }
}
